/**
 * Created by hp on 2017/5/27.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {TimeStream} from '../../utils';
import config from '../../config'
import '../../styles/classroom/ClassroomAudioArea.css';
import tips_icon from '../../images/tips-icon.png';

class ClassroomAudioArea extends Component {
    constructor() {
        super();
        this.onControlAudio = this.onControlAudio.bind(this);
        this.onAudioTimeUpdate = this.onAudioTimeUpdate.bind(this);
        this.onAudioLoad = this.onAudioLoad.bind(this);
        this.onAudioPlay = this.onAudioPlay.bind(this);
        this.onAudioPause = this.onAudioPause.bind(this);
        this.onAudioEnded = this.onAudioEnded.bind(this);

        this.handleProgress = this.handleProgress.bind(this);
        this.onMouseMove = this.onMouseMove.bind(this);
        this.onMouseUp = this.onMouseUp.bind(this);
        this.onMouseDown = this.onMouseDown.bind(this);

        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchMove = this.onTouchMove.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);
    }

    state = {
        angle: 0,
        currentTime: '00:00',
        totalTime: '00:00',
        duration: 0,
        progressBarWidth: 0,
        dragProgressWidth: 0,
        isAudioPlay: false,
    };

    componentDidMount() {
        window.addEventListener('mousemove', this.onMouseMove)
        window.addEventListener('mouseup', this.onMouseUp)


        let {angle} = this.state;
        this.ticksPlayIt = setInterval(() => {
            if (this.state.isAudioPlay) {
                angle += 1;
                if (angle >= 360) {
                    angle = 0;
                }
                this.setState({angle: angle});
            }
        }, 50);
    }

    componentWillUnmount() {
        window.removeEventListener('mousemove', this.onMouseMove)
        window.removeEventListener('mouseup', this.onMouseUp)
        this.ticksPlayIt && clearInterval(this.ticksPlayIt)
    }

    onAudioLoad() {
        let wkAudio = this.refs.wkAudio,
            duration = wkAudio.duration;
        if (!isNaN(duration)) {
            this.setState({
                duration: duration,
                totalTime: this.toTime(duration)
            })

            const lastCurrentTime = localStorage.getItem('lastAudioCurrentTime/' + this.props.lecture.id)
            if(lastCurrentTime && !this.state.duration){
                this.refs.wkAudio.currentTime = lastCurrentTime
                const {role} = this.props
                if (!role.is_manager && !role.is_lecturer) {
                    this.refs.wkAudio.play()
                }
            }
        }
    }

    onAudioPause() {
        this.setState({isAudioPlay: false})
    }

    onAudioPlay() {
        this.setState({isAudioPlay: true})
    }

    onAudioEnded() {
        localStorage.removeItem('lastAudioCurrentTime/' + this.props.lecture.id)
    }

    lastUpdateTime = null

    onAudioTimeUpdate() {
        let wkAudio = this.refs.wkAudio;
        let duration = this.state.duration;
        let currentTime = Math.min(wkAudio.currentTime, this.state.duration);

        const time = Math.floor(currentTime * 3) / 3.0;
        if (time !== this.lastUpdateTime) {
            this.handleProgress(currentTime, duration);
            this.lastUpdateTime = time
        }
    }

    toTime(ts, type) {
        const second = ts % 60
        const minute = ts / 60
        let secondStr = Math.floor(second).toString()
        if (secondStr.length === 1)
            secondStr = '0' + secondStr
        let minuteStr = Math.floor(minute).toString()
        if (minuteStr.length === 1)
            minuteStr = '0' + minuteStr
        return minuteStr + ':' + secondStr;
    }

    onControlAudio(e) {
        let wkAudio = this.refs.wkAudio;
        if (!this.state.isAudioPlay) {
            wkAudio.play();
        } else {
            wkAudio.pause();
        }
    }

    handleProgress(currentTime, duration) {
        let progress = (100 / duration * currentTime);

        this.setState({
            progressBarWidth: progress,
            dragProgressWidth: progress,
            currentTime: this.toTime(currentTime)
        });

        // 保存音频进度
        localStorage.setItem('lastAudioCurrentTime/' + this.props.lecture.id, currentTime)
    }

    onTouchStart(e) {
        this.dragStartLeft = e.touches[0].clientX
        this.dragStartTargetLeft = e.target.offsetLeft
    }

    onTouchMove(e) {
        if (!this.dragStartLeft)
            return
        this.onMove(e.changedTouches[0].clientX)
    }

    onTouchEnd(e) {
        this.onMouseUp(e)
    }

    dragStartLeft = null
    dragStartTargetPos = null
    dragProgress = null

    onMouseDown(e) {
        this.dragStartLeft = e.clientX
        this.dragStartTargetLeft = e.target.offsetLeft
    }

    onMove(x) {
        let dx = x - this.dragStartLeft
        let offsetLeft = this.dragStartTargetLeft + dx
        const pointW = 3
        if (offsetLeft < -pointW) {
            offsetLeft = -pointW
        } else if (offsetLeft > this.refs.drag_box.clientWidth - pointW) {
            offsetLeft = this.refs.drag_box.clientWidth - pointW
        }
        this.dragProgress = (100 * (offsetLeft + pointW) / this.refs.drag_box.clientWidth)
        this.refs.drag_btn.style.left = this.dragProgress + '%'
    }

    onMouseMove(e) {
        if (!this.dragStartLeft)
            return
        this.onMove(e.clientX)
    }

    onMouseUp(e) {
        if (!this.dragStartLeft)
            return
        if (this.dragProgress && this.refs.wkAudio && this.refs.wkAudio.duration) {
            this.refs.wkAudio.currentTime = parseFloat(this.dragProgress) * this.refs.wkAudio.duration / 100
        }
        this.dragStartLeft = null
        this.setState({dragProgressWidth: this.dragProgress})
    }

    render() {
        let {angle, currentTime, totalTime, progressBarWidth, dragProgressWidth} = this.state;
        let {audioArea, showTopVideo, lecture, liveroom, role, isLectureBegin} = this.props;

        if (this.dragStartLeft)
            dragProgressWidth = this.dragProgress

        return (
            <div className="wk-audio-body"
                 style={{height: audioArea.height + 'px', display: showTopVideo ? 'block' : 'none'}}>
                {(!isLectureBegin && showTopVideo && !(role.is_manager || role.is_lecturer)) ?
                    <div className="classroom-no-audio" style={{fontSize: '16px'}}>
                        <p><img src={tips_icon} style={{width: "50%"}} alt="tips_icon"/></p>
                        <p>开课时间: {TimeStream(lecture.start_timestamp, 'MD_HM')}</p>
                        <p>敬请期待</p>
                    </div>
                    :
                    lecture.audio_play_url ?
                        <div id="id_audio_container" className="wk-audio-box weui-flex"
                             style={{
                                 backgroundImage: `url(${lecture.cover_url})`,
                                 height: audioArea.height + 'px'
                             }}>
                            <div className="wk-audio-mask"></div>
                            <audio id="wk_audio_player"
                                   ref="wkAudio"
                                   src={lecture.audio_play_url}
                                   preload="metadata"
                                   onTimeUpdate={this.onAudioTimeUpdate}
                                   onCanPlayThrough={this.onAudioLoad}
                                   onPlay={this.onAudioPlay}
                                   onPause={this.onAudioPause}
                                   onEnded={this.onAudioEnded}
                            />
                            <div className="audio-control weui-flex" onClick={this.onControlAudio}>
                                <img id="wk-audio-img"
                                     className="audio-img bg"
                                     src={liveroom.avatar_url}
                                     style={{transform: 'rotate3d(0, 0, 1, ' + angle + 'deg)'}}
                                     alt=""/>
                                <div
                                    className={"control-btn " + (this.state.isAudioPlay ? "pause-btn" : "play-btn")}></div>
                            </div>
                            <div className="wk-audio-progress">
                                <div className="drag-progress-box novisible" id="drag-progress-box">
                                    <div className="current-time time-show">{currentTime}</div>
                                    <div className="drag-box" ref="drag_box">
                                        <div className="drag-progress" style={{width: dragProgressWidth + '%'}}></div>
                                        <div className="drag-btn" ref="drag_btn" style={{left: dragProgressWidth + '%'}}
                                             onTouchStart={this.onTouchStart}
                                             onTouchMove={this.onTouchMove}
                                             onTouchEnd={this.onTouchEnd}
                                             onMouseDown={this.onMouseDown}
                                        ></div>
                                    </div>
                                    <div className="duration time-show">{totalTime}</div>
                                </div>
                                <div className="wk-audio-progress-bar" style={{width: progressBarWidth + '%'}}></div>
                            </div>
                        </div>
                        :
                        role.is_lecturer ?
                            <div className="classroom-no-audio">
                                <p>尚未上传音频</p>
                                <p style={{marginTop: '10px'}}>请登录讲师管理后台-课程管理操作上传</p>
                                {['ios', 'android'].indexOf(window.systemType) > -1 ?
                                    <p>({config.ADMIN_BASE_URL}/lecture/)</p>
                                    :
                                    <p>(<a className="wk-link" href={config.ADMIN_BASE_URL+"/lecture/"} target="_blank">{config.ADMIN_BASE_URL}/lecture/</a>)</p>
                                }
                            </div>
                            :
                            <div className="classroom-no-audio">
                                暂无可播放的音频文件
                            </div>
                }
            </div>
        );
    }
}

export default connect((state) => ({
    audioArea: state.audioArea,
    lecture: state.classroom.lecture,
    liveroom: state.classroom.liveroom,
    showTopVideo: state.classroom.showTopVideo,
    role: state.classroom.role,
}))(ClassroomAudioArea)



// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomAudioArea.js